// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (min-width: 300px) and (max-width: 520px){.hw-happay-loader-text{text-align:center}}\n", ""]);
// Exports
module.exports = exports;
